import _ from 'underscore';
import OrdersActionCreators from '../../../actions/OrdersActionCreators';

import {
  getStopTypes,
  getStopLocationTypes,
  mapRequiresEquipment,
} from '../../../config/stops';

import { DEFAULT_LOCATION } from '../../../config/locations';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import { isOrderHazmat } from 'helpers/order-types';

export const mapGenerateStop = (order, equipment) => {
  const locations = getStopLocationTypes(order);
  const stopTypes = getStopTypes(order);
  const requiresEquipment = mapRequiresEquipment(order);
  const hasEquipment = !_.isEmpty(equipment);
  const isHazardous = isOrderHazmat(order);

  return (sequence) => {
    const { action, empty } = stopTypes[sequence - 1];

    const locType = locations[sequence - 1];
    const stop = {
      action,
      empty,
      sequence,
      window_start: null,
      window_end: null,
      appointment: false,
    };

    if (hasEquipment && requiresEquipment(sequence)) {
      stop.equipments = [equipment];
    }

    if (order[locType] && order[locType].length) {
      const location = order[locType][0];
      stop.location = {
        name: location.name || '',
        address: location.address,
      };
      stop.contacts = location.contact ? [location.contact] : [];
    } else {
      // TODO: we should probably just show a link that says 'add location' if there isn't one
      // using this as a quick workaround for the short term
      stop.location = { ...DEFAULT_LOCATION };
    }

    if (isHazardous) {
      if (
        featureEnabled(CONFIGURED_FEATURES.ENABLE_MULTIPLE_HAZMAT_DETAILS) &&
        order.hazmat_details?.length
      ) {
        stop.hazards = order.hazmat_details.map((h) => {
          return {
            imo_class: h.hazmat_class,
            packing_group: h.hazmat_packaging_group,
            description: h.hazmat_description,
          };
        });
      } else {
        stop.hazards = [
          {
            imo_class: order.hazmat_class,
            packing_group: order.hazmat_packaging_group,
            description: order.hazmat_description,
          },
        ];
      }
    }
    return stop;
  };
};

export const createShipment = (props, options) => {
  OrdersActionCreators.createShipmentFromOrder(props.order._id, options);
};
